import { OnInit, EventEmitter } from '@angular/core';
import { ThemeSettingService } from '../services/theme-setting.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
var ModalControlComponent = /** @class */ (function () {
    function ModalControlComponent(themeSettingService, bsModalRef, modalService) {
        this.themeSettingService = themeSettingService;
        this.bsModalRef = bsModalRef;
        this.modalService = modalService;
        this.isBusy = false;
        this.actions = [];
        this.expandSummary = false;
        this.subSelectedId = new EventEmitter();
    }
    ModalControlComponent.prototype.handleKeyup = function (event) {
        if (event.keyCode === 8 && event.target.tagName.toUpperCase() != "INPUT" && event.target.tagName.toUpperCase() != "TEXTAREA") {
            event.preventDefault();
        }
    };
    ModalControlComponent.prototype.ngOnInit = function () {
        this.loaderConfig = this.themeSettingService.getTheme();
    };
    ModalControlComponent.prototype.hide = function () {
        this.bsModalRef.hide();
    };
    ModalControlComponent.prototype.onSelected = function ($event) {
        this.openPopup($event, "");
    };
    ModalControlComponent.prototype.setActions = function (actions) {
        this.actions = actions;
    };
    ModalControlComponent.prototype.openPopup = function (event, title) {
        var _this = this;
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'modal-dialog-centered modal-detail',
            initialState: {
                componentId: event,
                title: title
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
        });
        this.modalRef = this.modalService.show(DetailPopupComponent, config);
    };
    ModalControlComponent.prototype.setCurrentAction = function (action) {
        var _this = this;
        if (this.currentAction) {
            if (this.currentAction.ActionName == action.ActionName) {
                this.currentAction = null;
                setTimeout(function () {
                    _this.currentAction = action;
                });
            }
            else {
                this.currentAction = action;
            }
        }
        else {
            this.currentAction = action;
        }
    };
    ModalControlComponent.prototype.handleLoading = function (event) {
        this.isBusy = event;
    };
    return ModalControlComponent;
}());
export { ModalControlComponent };
